import { STORE_USERS, STORE_USER_BILLING_MAP, UPDATE_USER_BILLING_ENTRY, REMOVE_USER, STORE_COMPANY_DETAILS_MAP } from '../actions/types';

const initialState = {
    users: [],
    billingMap: {},
    companyMap: {},
};

const usersReducer = (state = initialState, action) => {
    switch (action.type) {
        case STORE_USERS:
            return { ...state, users: action.payload };
        case STORE_USER_BILLING_MAP:
            return { ...state, billingMap: action.payload };
        case UPDATE_USER_BILLING_ENTRY: {
            const { userId, ...updates } = action.payload;
            return {
                ...state,
                billingMap: {
                    ...state.billingMap,
                    [userId]: { ...(state.billingMap[userId] || {}), ...updates },
                },
            };
        }
        case STORE_COMPANY_DETAILS_MAP:
            return { ...state, companyMap: action.payload };
        case REMOVE_USER: {
            const removedId = action.payload;
            const billingMap = { ...state.billingMap };
            const companyMap = { ...state.companyMap };
            delete billingMap[removedId];
            delete companyMap[removedId];
            return {
                ...state,
                users: state.users.filter(u => u.id !== removedId),
                billingMap,
                companyMap,
            };
        }
        default:
            return state;
    }
};

export default usersReducer;
